import { render, staticRenderFns } from "./AdminReviewEditAbout.vue?vue&type=template&id=8871bef6&scoped=true&"
import script from "./AdminReviewEditAbout.vue?vue&type=script&lang=ts&"
export * from "./AdminReviewEditAbout.vue?vue&type=script&lang=ts&"
import style0 from "./AdminReviewEditAbout.vue?vue&type=style&index=0&id=8871bef6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8871bef6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
